<template>
  <v-navigation-drawer v-model="showDrawer" clipped app :mini-variant="mini">
    <v-layout>
      <v-flex>
        <v-list dense v-if="!mini">
          <v-list-item
            v-for="item in menuItems"
            :key="item.name"
            :to="item.goToPath"
            active-class="grey lighten-2 active-menu-item"
          >
          <v-list-item-avatar>
              <v-icon large>group</v-icon>
            </v-list-item-avatar>
            <v-list-item-content
              class="text-uppercase user-menu-text"
            >
              <v-list-item-title v-text="item.name"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-flex>
    </v-layout>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'UsersManagementSideBar',
  props: {
    show: Boolean,
    menuItems: Array,
  },
  data: () => ({
    mini: false,
  }),
  computed: {
    showDrawer: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('visibility-changed', val);
      },
    },
  },
};
</script>

<style scoped lang="scss">
  .user-menu-text{
    font-family: Ubuntu;
  }
</style>
